/* global G */
import { setKey } from 'lib/util'

/**
 * HTTP middleware filter that excludes `persistence`.
 *
 * @param params              http adapter middleware
 * @param params.persistence  excluded middleware
 * @param params.rest         used middleware
 * @return {any[]}
 */
const middleware = ({ persistence, ...rest }) => Object.values(rest)

/**
 * Model Password Validator
 *
 * validates data values on model level, propagating
 * to the same scope as children validators
 *
 * It makes remote request to login end point
 *
 * @param obj - model composition
 * @param args - prolly only value, or nothing at all
 * @returns {function(...[*]): *[]}
 */
const fn = obj => async (...args) => {
  try {
    const { api, version } = obj[G.PROPS]
    const params = {
      ...obj[G.DATA],
    }
    const url = `/api/v${version}/${api}/login`
    const meta = await obj[G.ADAPTER][G.HTTP].post({ url, params }, { middleware })
    setKey(obj[G.ADAPTER][G.SESSION] || {}, G.SESSION, obj[G.ADAPTER])
    setKey(meta, G.META, obj[G.ADAPTER][G.SESSION])
    args.push(meta)
  } catch (e) {
    console.warn(e.message)
    console.log(e)
    throw e
  }
  return args
}

export default fn
